import { Country } from 'models/Country';

import { UseCompanyModalsReturn } from '../hooks/useCompanyModals';
import ChangePasswordModal from './ChangePasswordModal';
import DetailCompanyModal from './DetailCompanyModal';
import NewCompanyModal from './NewCompanyModal';
import NewMenuDetailModal from './NewMenuDetailModal';

interface CompanyModalsProps {
  modals: UseCompanyModalsReturn;
  countries: Country[];
}

function CompanyModals({ modals, countries }: CompanyModalsProps) {
  const {
    isNewCompanyModalOpen,
    isDetailModalOpen,
    isMenuDetailModalOpen,
    isChangePasswordModalOpen,
    selectedRow,
    selectedRowForPassword,
    closeNewCompanyModal,
    closeDetailModal,
    closeMenuDetailModal,
    closeChangePasswordModal,
    createNewCompany,
    editCompany,
    handleChangePassword,
  } = modals;

  return (
    <>
      <NewCompanyModal
        isOpen={isNewCompanyModalOpen}
        handleModalCancel={closeNewCompanyModal}
        submit={createNewCompany}
        countries={countries}
      />

      {selectedRow && (
        <DetailCompanyModal
          isOpen={isDetailModalOpen}
          id={selectedRow.id}
          handleModalCancel={closeDetailModal}
          submit={editCompany}
          countries={countries}
        />
      )}

      {selectedRow && (
        <NewMenuDetailModal
          company={selectedRow}
          isOpen={isMenuDetailModalOpen}
          handleModalCancel={closeMenuDetailModal}
        />
      )}

      {selectedRowForPassword && (
        <ChangePasswordModal
          isOpen={isChangePasswordModalOpen}
          handleModalCancel={closeChangePasswordModal}
          submit={handleChangePassword}
          companyName={selectedRowForPassword.name}
          companyId={selectedRowForPassword.id}
        />
      )}
    </>
  );
}

export default CompanyModals;
